import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-project-frequencie',
  templateUrl: './project-frequencie.component.html',
  styleUrls: ['./project-frequencie.component.scss']
})
export class ProjectFrequencieComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() projectFrequencies!: any[];
  @Input() kickOffDateList!: any[];

  constructor() { }

  ngOnInit(): void {
  }

  setFrequency(frequencyUuid: string) {
    this.form.get('frequency')?.setValue(frequencyUuid);
  }

  setKickOffDateRadioBtn(kickOffDateSelectedValue: any) {
    this.form.get('checkinStartDate')?.setValue(kickOffDateSelectedValue);
  }

}
